/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespHeroCarouselRequestMoreImages_user = {
    readonly serviceId: string | null;
    readonly " $fragmentRefs": FragmentRefs<"SharedContactDealerWrapper_user">;
    readonly " $refType": "PdpRespHeroCarouselRequestMoreImages_user";
};
export type PdpRespHeroCarouselRequestMoreImages_user$data = PdpRespHeroCarouselRequestMoreImages_user;
export type PdpRespHeroCarouselRequestMoreImages_user$key = {
    readonly " $data"?: PdpRespHeroCarouselRequestMoreImages_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespHeroCarouselRequestMoreImages_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespHeroCarouselRequestMoreImages_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_user",
      "args": null
    }
  ]
};
(node as any).hash = '1312d899977bc0e275bac12dd2af63cc';
export default node;
